export default "/assets/images/accessory-img-01.webp?1c445718ee2ef6b87778c7dacf254e92";